export default function ConfirmPage() {
  return null;
}
